const initialState = {
  ports: [],
  loading: false,
  error: null
};

const PortReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PORTS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PORTS_SUCCESS':
      return { ...state, loading: false, ports: action.payload, error: null };
    case 'FETCH_PORTS_FAILURE':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default PortReducer;
